export const formatCurrency = (inputText: string, showSymbol: boolean = true) => {
  let value = inputText;
  value = value.replace(/\D/g, "");
  const numberValue = Number(value) / 100;
  let formatted = numberValue.toLocaleString("pt-BR", {
    style: showSymbol ? "currency" : "decimal",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });


  if (!showSymbol) {
    formatted = formatted.replace(/^R\$\s?/, "");
  }

  return formatted;
};


export function parseCurrencyBRL(value: string): number {
  if (!value) return 0;

  // Remove currency symbol (R$), spaces, and other non-numeric characters except dots and commas
  const cleanValue = value.replace(/[R$\s]/g, '').trim();
  if (!cleanValue) return 0;

  // Convert from pt-BR format (1.234,56) to number format (1234.56)
  const normalized = cleanValue.replace(/\./g, '').replace(',', '.');
  const parsed = parseFloat(normalized);

  // Return 0 if parsing failed (NaN)
  return isNaN(parsed) ? 0 : parsed;
}

export const formatValue = (value: number, showCurrencySymbol = true): string => {
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
  
  if (!showCurrencySymbol) {
    return formattedValue.replace('R$', '').trim();
  }
  
  return formattedValue;
};

export const formatFileName = (file?: string) => {
  if (!file) return '';
  
  const noAccents = file.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return noAccents.replace(/\s+/g, '-');
}

